package navigation.home.proposal.allproposal

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.area.domain.repository.AreaRepository
import com.essntl.features.profile.domain.repository.ProfileRepository
import com.essntl.features.proposal.domain.repository.ProposalRepository
import com.essntl.features.proposal.ui.allproposal.AllProposalEvent
import com.essntl.features.proposal.ui.allproposal.AllProposalState
import com.essntl.features.proposal.ui.allproposal.AllProposalViewModel
import com.essntl.toastmanager.ToastManager

class AllProposalScreenModel(
    proposalRepository: ProposalRepository,
    areaRepository: AreaRepository,
    profileRepository: ProfileRepository,
    toastManager: ToastManager,
    loadingManager: LoadingManager,
) : StateScreenModel<AllProposalState>(AllProposalState()) {
    private val allProposalViewModel =
        AllProposalViewModel(
            proposalRepository = proposalRepository,
            areaRepository = areaRepository,
            profileRepository = profileRepository,
            toastManager = toastManager,
            scope = screenModelScope,
            state = mutableState,
            loadingManager = loadingManager,
        )

    fun onEvent(event: AllProposalEvent) {
        allProposalViewModel.onEvent(event)
    }
}
